import { jsonb, pgTable, text, timestamp } from 'drizzle-orm/pg-core';

/**
 * Tabela `railway_costs` — CACHE do custo estimado por projeto do Railway.
 *
 * Não é dado de negócio: é um espelho descartável da resposta da API pública do
 * Railway (`estimatedUsage` + de-para projeto→repositório), guardado só para não
 * repetir a consulta a cada abertura da tela. Ver `docs/railway-custos.md`.
 *
 * POR QUE CACHE NO POSTGRES E NÃO EM MEMÓRIA:
 *  - a API pode rodar com mais de uma réplica (Railway escala horizontalmente),
 *    e cache em memória multiplicaria a consulta pelo número de réplicas — o
 *    requisito explícito era NÃO aumentar o consumo da API do Railway;
 *  - deploy/restart zeraria o cache em memória; aqui o snapshot sobrevive;
 *  - previsibilidade: com a janela de 60 min, o pior caso é 1 requisição/hora
 *    para o workspace INTEIRO, e ZERO quando ninguém abre a tela (o refresh é
 *    sob demanda — não existe cron nem serviço novo por causa disto).
 *
 * MODELAGEM: uma linha por workspace (`workspace_id` é a PK natural), o que dá
 * o `ON CONFLICT DO UPDATE` idempotente do refresh — dois requests simultâneos
 * com o snapshot vencido escrevem a mesma linha, sem duplicar nem estourar.
 *
 * `snapshot` guarda o resultado JÁ CALCULADO (o array `custos` do contrato da
 * rota), não a resposta crua: a tela serve exatamente o que foi gravado, e
 * `fetched_at` é literalmente o `atualizadoEm` que o cliente recebe. O preço da
 * escolha é que mudança de preço/fórmula só aparece no próximo refresh (≤ 1h) —
 * aceitável para um número que já é ESTIMATIVA.
 */
export const railwayCosts = pgTable('railway_costs', {
  workspaceId: text('workspace_id').primaryKey(),
  snapshot: jsonb('snapshot').notNull(),
  fetchedAt: timestamp('fetched_at', { withTimezone: true }).notNull().defaultNow(),
});

export type RailwayCostsRow = typeof railwayCosts.$inferSelect;
export type NewRailwayCostsRow = typeof railwayCosts.$inferInsert;
